const _ = require('lodash')

/**
 * Convert one or more URLs into a background-image CSS rule
 * @param {?(string|string[])} imageUrls
 * @returns {string}
 */
exports.backgroundImage = function (imageUrls) {
  // https://www.w3.org/TR/css-backgrounds-3/#the-background-image
  const value = exports.imageLayers(imageUrls)
  if (value) {
    return `background-image: ${value}; `
  }
  return ''
}

exports.imageLayers = function (...urls) {
  // https://www.w3.org/TR/css-backgrounds-3/#layering
  return _.flatten(urls)
  .filter(url => !!url)
  .map(exports.urlToken)
  .join(', ')
}

/**
 * Returns an escaped CSS url-token value
 * @param {string} url
 * @returns {string}
 */
exports.urlToken = function (url) {
  // https://drafts.csswg.org/css-syntax-3/#consume-a-url-token
  // https://drafts.csswg.org/css-syntax-3/#url-token-diagram
  const escapedUrl = url.replace(/([()'"\\\s])/g, '\\$1')
  return `url(${escapedUrl})`
}

/**
 * Returns CSS display style to hide an element or change its rendering type.
 * If Boolean `false` value is provided, the element will be hidden.
 * If `true`, `null`, or `undefined` value is provided, no display style is returned.
 * If string value is provided, it will be used as the value to the CSS display property.
 * @param {?(boolean|string)} [display] - Boolean or string representing a CSS display value
 * See: https://developer.mozilla.org/en-US/docs/Web/CSS/display
 */
exports.display = function (display) {
  if (display === true || display == null) {
    return ''
  }
  if (display === false) {
    return 'display: none; '
  }
  return `display: ${display}; `
}

/**
 * Returns a function that composes base class name(s) with a suffix string.
 * Used in modals as a proto-BEM pattern to re-use styles across components
 * Deprecated. Do not use for new components.
 * @param {(string|string[])} classNames
 * @param {string} [separator]
 */
exports.classSuffixer = function (classNames, separator = '__') {
  if (_.isString(classNames)) {
    classNames = classNames.split(' ')
  }
  if (_.isArray(classNames)) {
    classNames = _.compact(classNames)
  }
  if (!_.isArray(classNames) || !classNames.length) {
    return _.noop
  }
  return function (suffix) {
    return classNames
    .map(className => className + separator + suffix)
    .join(' ')
  }
}
